import "core-js/modules/es.array.sort.js";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import "core-js/modules/es.array.sort.js";
import React, { useContext } from 'react';
import pt from 'prop-types';
import getConfig from '../../js/settings';
import { isServer } from '../../js/util';
var BreakpointHelper = /*#__PURE__*/function () {
  function BreakpointHelper() {}
  BreakpointHelper.getMediaQueries = function getMediaQueries() {
    if (!this.mediaQueries) {
      var BROWSER_DEFAULT_FONT_SIZE = getConfig('BROWSER_DEFAULT_FONT_SIZE');
      var BREAKPOINT = getConfig('BREAKPOINT');
      var BREAKPOINT_PRINT = getConfig('BREAKPOINT_PRINT');
      var queries = [];
      for (var name in BREAKPOINT) {
        if (!BREAKPOINT.hasOwnProperty(name)) continue;
        var bp = BREAKPOINT[name];
        var width = bp.width / BROWSER_DEFAULT_FONT_SIZE;
        var print = name === BREAKPOINT_PRINT;
        var query = (print ? 'print,' : '') + ("screen and (min-width: " + width + "em)");
        queries.push({
          name: name,
          width: width,
          query: query
        });
      }
      this.mediaQueries = queries.sort(function (a, b) {
        return a.width - b.width;
      });
    }
    return this.mediaQueries;
  };
  BreakpointHelper.getBreakpointValue = function getBreakpointValue(isServerSide) {
    if (isServerSide === void 0) {
      isServerSide = false;
    }
    var queries = this.getMediaQueries();
    if (!queries || queries.length <= 0) return null;
    var breakpoints = {},
      max = queries[queries.length - 1].name;
    if (!isServerSide && this.canQueryMedia()) {
      for (var i = 0; i < queries.length; i++) {
        var q = queries[i],
          mql = this.match(q.query);
        if (i > 0 && !mql.matches) {
          max = queries[i - 1].name;
          break;
        }
      }
    } else {
      max = getConfig('DEFAULT_SSR_BREAKPOINT');
    }

    // priority is positive for matching queries, the higher the value the higher priority if multiple queries match
    var priority = 0;
    var reachedMax = false;
    queries.forEach(function (q) {
      var only = -1,
        down = -1,
        up = -1;
      if (max === q.name) {
        only = Number.MAX_VALUE;
        down = priority++;
        up = priority++;
        reachedMax = true;
      } else if (!reachedMax) {
        up = priority++;
      } else {
        down = priority++;
      }
      breakpoints[q.name + "Only"] = only;
      breakpoints[q.name] = up;
      breakpoints[q.name + "Down"] = down;
    });
    return {
      breakpoints: breakpoints,
      max: max
    };
  };
  BreakpointHelper.canQueryMedia = function canQueryMedia() {
    return !isServer() && window.hasOwnProperty('matchMedia');
  };
  BreakpointHelper.match = function match(query) {
    return window.matchMedia(query);
  };
  return BreakpointHelper;
}();
BreakpointHelper.mediaQueries = null;
var BreakpointContext = /*#__PURE__*/React.createContext(BreakpointHelper.getBreakpointValue());
var BreakpointContextProvider = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BreakpointContextProvider, _React$Component);
  function BreakpointContextProvider(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      value: _this.getValue(props.isServerSide)
    };
    return _this;
  }
  var _proto = BreakpointContextProvider.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    if (!BreakpointHelper.canQueryMedia()) return;
    var value = this.getValue();
    if (value.max !== this.state.value.max) {
      console.log("Breakpoint mismatch of predicted (" + this.state.value.max + ") vs actual (" + value.max + ") viewport - reloading content");
      this.setState({
        value: value
      });
    }
    var queries = BreakpointHelper.getMediaQueries();
    queries.forEach(function (q) {
      var mql = BreakpointHelper.match(q.query);
      mql.addListener(_this2.onMediaQueryChange.bind(_this2));
      BreakpointContextProvider.mqls.push(mql);
    });
  };
  _proto.onMediaQueryChange = function onMediaQueryChange(e) {
    this.setState({
      value: this.getValue()
    });
  };
  _proto.getValue = function getValue(isServerSide) {
    if (isServerSide === void 0) {
      isServerSide = false;
    }
    return BreakpointHelper.getBreakpointValue(isServerSide);
  };
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(BreakpointContext.Provider, {
      value: this.state.value
    }, this.props.children);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this3 = this;
    BreakpointContextProvider.mqls.forEach(function (mql) {
      mql.removeListener(_this3.onMediaQueryChange);
    });
    BreakpointContextProvider.mqls.splice(0, BreakpointContextProvider.mqls.length);
  };
  return BreakpointContextProvider;
}(React.Component);
BreakpointContextProvider.mqls = [];
BreakpointContextProvider.defaultProps = {
  isServerSide: false
};
function breakpointSwitch(options, contextValue) {
  if (!options || typeof options != 'object') return null;
  if (!contextValue) contextValue = BreakpointHelper.getBreakpointValue();
  var _contextValue = contextValue,
    breakpoints = _contextValue.breakpoints;
  var option = null;
  var priority = -1;
  for (var i in options) {
    if (options.hasOwnProperty(i) && breakpoints.hasOwnProperty(i) && breakpoints[i] > priority) {
      option = options[i];
      priority = breakpoints[i];
    }
  }
  return option;
}
function breakpointPropSwitch(options, contextValue) {
  var responsive = false;
  var breakpoints = contextValue.breakpoints;
  if (typeof options == 'object') {
    responsive = true;
    for (var i in options) {
      if (options.hasOwnProperty(i) && !breakpoints.hasOwnProperty(i)) {
        responsive = false;
        break;
      }
    }
  }
  return responsive ? breakpointSwitch(options, contextValue) : options;
}
var Breakpoint = /*#__PURE__*/function (_React$Component2) {
  _inheritsLoose(Breakpoint, _React$Component2);
  function Breakpoint() {
    return _React$Component2.apply(this, arguments) || this;
  }
  var _proto2 = Breakpoint.prototype;
  _proto2.render = function render() {
    return breakpointSwitch(this.props, this.context);
  };
  return Breakpoint;
}(React.Component);
Breakpoint.contextType = BreakpointContext;
var propTypes = {};
Object.keys(getConfig('BREAKPOINT')).forEach(function (name) {
  propTypes[name] = pt.node;
});
var useBreakpoint = function useBreakpoint(options) {
  var context = useContext(BreakpointContext);
  return breakpointPropSwitch(options, context);
};
export { Breakpoint, BreakpointContext, BreakpointContextProvider, breakpointSwitch, breakpointPropSwitch, useBreakpoint };